export const devMode = false; // true = mode dev activé | false = mode normal
export const devModePage = "home"; // Options: "home", "cart", "intro"
export const devModeAddTestCart = false; // Ajoute des produits de test au panier en mode dev

import "../style/fonts/cabinet-grotesk.css";
import "../style/fonts/satoshi.css";
import "../style/fonts/damion.css";
import "../style/loader.css";
import "../style/global.css";
import "../style/intro.css";
import "../style/home.css";
import "../style/cart.css";
import "../style/404.css";

import { setupRouter } from "./router.js";
import { appState } from "./router.js";
import router from "./router.js";
import { createElement, ShoppingCart } from "lucide";
import { gsap } from "gsap";

export const emailjsPublicKey = "bZaeMV7DU1FYhFNTP";

import { init } from "@emailjs/browser";

init(emailjsPublicKey);

const nombreImageTrail = 10;
const pathImageTrail = "/assets/images/home/img-trail/";
const nombreImageProducts = 6;
const pathImageProducts = "/assets/images/home/products/";
const assets = [
  ...Array.from(
    { length: nombreImageTrail },
    (_, i) => `${pathImageTrail}${i + 1}.avif`
  ),
  ...Array.from(
    { length: nombreImageProducts },
    (_, i) => `${pathImageProducts}${i + 1}.avif`
  ),
  "/assets/images/home/images-description.avif",
  "/assets/images/home/images-description-2.avif",
];

function loadAsset(url) {
  return new Promise((resolve) => {
    const img = new Image();
    img.src = url;
    resolve();
  });
}

export let cursorX = null;
export let cursorY = null;

export const cartItemsState = {
  cartItems: [],
  cartItemsQuantity: 0,
};

export const state = {
  finIntro: false,
};
let menuCreated = false;
document.addEventListener("mousemove", (e) => {
  cursorX = e.clientX;
  cursorY = e.clientY;
});

export function createMenu() {
  if (menuCreated) return;
  menuCreated = true;
  document.body.innerHTML += `
  <div class="logo-rapha-container">
    <svg
          width="100%"
          height="100%"
          viewBox="0 0 344 171"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
          xml:space="preserve"
          xmlns:serif="http://www.serif.com/"
          class="logo-rapha"
        >
          <rect
            id="Plan-de-travail1"
            serif:id="Plan de travail1"
            x="0"
            y="0"
            width="344"
            height="171"
            style="fill: none"
          />
          <g>
            <path
              d="M299.688,96.852c-5.484,3.42 -12.665,2.089 -9.39,-7.879c3.117,-9.33 10.849,-14.735 15.855,-14.735c5.3,0 8.171,3.299 9.721,6.051c-3.426,5.455 -8.381,11.676 -16.186,16.563Zm-196.734,0c-5.488,3.42 -12.68,2.089 -9.394,-7.879c3.1,-9.33 11.238,-14.735 16.235,-14.735c5.285,0 7.844,3.275 9.346,6.03c-3.437,5.476 -8.38,11.697 -16.187,16.584Zm236.655,1.685c-2.18,-2.287 -4.943,-1.619 -7.753,0.339c-1.956,1.358 -5.222,1.489 -3.41,-6.177c1.721,-7.278 8,-19.159 8.891,-21.286c1.251,-2.966 -0.363,-6.626 -5.701,-7.069c-2.308,-0.172 -4.569,0.345 -6.819,2.193c-2.464,-2.797 -6.258,-5.384 -12.339,-5.384c-9.874,0 -23.474,7.54 -31.452,19.686c-4.388,6.567 -10.415,13.714 -17.18,18.169c-2.079,1.394 -4.495,2.129 -5.985,1.597c-3.077,-1.127 -2.206,-5.647 4.42,-13.198c10.623,-12.114 13.647,-21.224 7.475,-26.619c-4.2,-3.664 -11.109,-4.077 -18.126,-0.772c-7.444,3.49 -11.664,7.315 -15.538,11.273c9.741,-20.169 21.903,-43.743 29.999,-56.991c3.73,-6.182 3.73,-11.475 -1.551,-12.405c-4.643,-0.809 -9.367,1.428 -13.144,9.347c-8.69,18.206 -15.829,34.351 -24.331,52.501l0,-0.032c-5.503,11.059 -15.634,26.534 -28.914,35.301c-2.08,1.394 -4.489,2.129 -5.984,1.598c-3.111,-1.128 -2.196,-5.648 4.403,-13.198c10.607,-12.115 13.659,-21.225 7.486,-26.62c-4.215,-3.663 -11.135,-4.077 -18.152,-0.772c-9.217,4.329 -13.481,9.144 -18.296,14.103c4.051,-6.167 3.592,-11.843 -0.288,-13.085c-5.077,-1.632 -7.722,0.366 -12.568,14.073c-2.464,6.714 -9.154,19.448 -18.65,23.771c-2.196,0.997 -6.215,1.489 -4.392,-6.177c1.73,-7.279 7.982,-19.159 8.875,-21.286c1.256,-2.967 -0.348,-6.627 -5.665,-7.07c-2.35,-0.171 -4.59,0.345 -6.813,2.194c-2.474,-2.798 -6.3,-5.384 -12.381,-5.384c-12.873,0 -32.137,12.841 -36.908,31.997c-2.255,3.262 -6.552,6.722 -12.04,6.891c-9.832,0.257 -15.219,-8.442 -17.533,-18.556c22.123,-4.355 42.942,-16.683 46.975,-36.102c3.827,-18.388 -8.79,-34.322 -31.452,-33.834c-31.17,0.642 -52.209,23.138 -57.242,32.675c-3.526,6.666 -0.284,12.028 4.173,11.803c3.206,-0.131 9.196,-2.227 11.099,-8.777c3.004,-10.39 14.84,-22.362 34.905,-24.038c15.181,-1.28 23.807,8.355 22.4,20.821c-1.731,15.232 -16.65,23.956 -32.05,27.878l-0.038,-0.96c-0.032,-4.69 -0.428,-7.879 -3.596,-8.913c0.027,-1.66 -0.685,-2.95 -2.336,-3.717c-2.591,-1.159 -6.134,-1.028 -9.073,3.441c-10.731,16.531 -15.946,24.215 -26.366,37.871c-4.766,6.311 -4.91,12.871 -0.118,14.227c4.916,1.401 9.523,-0.627 13.493,-6.976c5.253,-8.416 9.65,-16.644 13.508,-23.671c1.048,-0.017 2.126,-0.081 3.175,-0.142c0.678,13.805 7.658,32.816 26.617,29.729c6.963,-1.133 11.777,-4.814 15.496,-8.312c2.725,7.743 11.895,9.57 21.054,5.242c9.224,-4.338 13.466,-9.126 18.281,-14.112c-5.564,14.195 5.103,24.623 21.824,11.13c0.71,-0.595 1.388,-1.165 2.051,-1.691c-8.368,17.482 -18.478,36.952 -24.757,50.281c-4.275,9.068 -2.292,13.189 3.041,13.621c5.321,0.398 8.448,-2.359 11.659,-10.035c4.318,-10.333 12.735,-32.799 25.982,-58.583c12.637,-24.634 28.893,-30.688 32.079,-28.59c3.409,2.204 -1.363,7.676 -8.583,16.854c-7.898,10 -7.54,18.28 -3.724,21.701c4.804,4.354 13.439,5.117 24.159,-3.556c3.274,-2.662 5.669,-4.919 7.599,-6.944c-3.363,6.714 -4.693,11.694 -0.14,13.521c3.035,1.202 7.081,0.331 9.128,-4.221c2.986,-6.675 9.801,-18.302 17.281,-26.417c9.502,-10.311 18.056,-12.208 20.023,-10.938c3.381,2.204 -1.39,7.676 -8.631,16.854c-7.882,10 -7.512,18.28 -3.719,21.701c4.821,4.354 13.441,5.117 24.17,-3.556c3.051,-2.459 5.329,-4.62 7.188,-6.516c0.538,11.266 11.161,14.521 21.829,9.497c9.206,-4.338 13.482,-9.126 18.312,-14.112c-4.944,14.917 8.796,23.798 22.321,11.502c3.435,-3.132 3.933,-6.984 2.367,-8.588Z"
            />
          </g>
    </svg>
  </div>
  <div class="menu">
    <div class="menu-content">
      <div class="menu-content-item" data-nav-item="home">
        <div>Home</div>
      </div>
      <div class="menu-content-item" data-nav-item="about">
        <div>About</div>
      </div>
      <div class="menu-content-item" data-nav-item="buy">
        <div>Buy</div>
      </div>
      <div class="menu-content-item" data-nav-item="gallery">
        <div>Gallery</div>
      </div>
      <div class="menu-content-item" data-nav-item="cart"></div>
    </div>
    <div class="menu-backdrop"></div>
  </div>
`;

  function scrollToSection(sectionSelector) {
    const section = document.querySelector(sectionSelector);
    if (section) {
      import("./home.js").then((module) => {
        if (module.currentSmoother) {
          module.currentSmoother.scrollTo(section, true, "top top");
        } else {
          section.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    }
  }

  const logoContainer = document.querySelector(".logo-rapha-container");
  const logo = document.querySelector(".logo-rapha");

  gsap.from(logo, {
    opacity: 0,
    x: -100,
    duration: 1,
    ease: "power3.out",
    delay: 0.35,
  });

  logoContainer.addEventListener("click", () => {
    if (appState.currentPage !== "home") {
      router.navigate("/home");
      setTimeout(() => {
        scrollToSection("#s1");
      }, 300);
    } else {
      scrollToSection("#s1");
    }
  });

  logoContainer.addEventListener("mouseenter", () => {
    gsap.to(logo, {
      scale: 1.05,
      duration: 0.3,
      ease: "power2.out",
    });
  });

  logoContainer.addEventListener("mouseleave", () => {
    gsap.to(logo, {
      scale: 1,
      duration: 0.3,
      ease: "power2.out",
    });
  });

  const menuContent = document.querySelector(".menu-content");
  gsap.from(menuContent, {
    scale: 0,
    duration: 0.8,
    ease: "elastic.out(1, 0.8)",
    delay: 0.35,
  });
  const menuNavItems = document.querySelectorAll(".menu-content-item");
  const menuNavCartIcon = document.querySelector(
    ".menu-content-item[data-nav-item='cart']"
  );
  menuNavCartIcon.append(
    createElement(ShoppingCart, {
      class: ["menu-nav-cart-icon"],
    })
  );
  const cartItemsLength = document.createElement("div");
  cartItemsLength.textContent = `• ${cartItemsState.cartItemsQuantity}`;
  cartItemsLength.classList.add("menu-nav-cart-items-length");
  menuNavCartIcon.append(cartItemsLength);
  menuNavItems.forEach((item) => {
    item.addEventListener("click", () => {
      const navItem = item.dataset.navItem;

      if (navItem === "cart") {
        router.navigate(`/${navItem}`);
        return;
      }

      const sectionMap = {
        home: "#s1",
        about: "#s2",
        buy: ".s2-products-container",
        gallery: "#s3",
      };

      const sectionSelector = sectionMap[navItem];
      if (sectionSelector) {
        if (appState.currentPage !== "home") {
          router.navigate("/home");
          setTimeout(() => {
            scrollToSection(sectionSelector);
          }, 300);
        } else {
          scrollToSection(sectionSelector);
        }
      }
    });
  });
  const menuButton = document.querySelector(".menu");
  const menuBackdrop = document.querySelector(".menu-backdrop");
  let menuOpen = false;
  menuContent.addEventListener("mouseenter", () => {
    if (menuOpen) return;
    menuOpen = true;
    menuContent.style.display = "flex";
    gsap.to(menuContent, {
      height: "45rem",
      width: "30rem",
      duration: 0.7,
      ease: "elastic.out(1, 0.8)",
      boxShadow: "0 0 30px rgba(0, 0, 0, 0.2)",
    });
    gsap.to(menuNavItems, {
      opacity: 1,
      y: 0,
      duration: 0.7,
      stagger: 0.05,
      ease: "power3.out",
      filter: "blur(0px)",
      delay: 0.35,
    });
    gsap.to(menuBackdrop, {
      backdropFilter: "blur(4px) saturate(60%) brightness(0.8)",
      duration: 0.7,
      delay: 0.15,
      ease: "power3.out",
      overwrite: true,
    });
    setTimeout(() => {
      menuOpen = true;
    }, 700);
  });
  menuContent.addEventListener("mouseleave", () => {
    if (!menuOpen) return;
    menuOpen = false;
    gsap.to(menuContent, {
      height: "0rem",
      width: "0rem",
      duration: 0.7,
      boxShadow: "0 0 30px rgba(0, 0, 0, 0)",
      ease: "power4.inOut",
      delay: 0.15,
    });
    gsap.to(menuNavItems, {
      opacity: 0,
      y: 100,
      duration: 0.7,
      stagger: -0.05,
      filter: "blur(7px)",
      ease: "power3.out",
    });
    gsap.to(menuBackdrop, {
      backdropFilter: "blur(0px) saturate(100%) brightness(1)",
      duration: 0.7,
      ease: "power3.out",
      delay: 0.5,
      overwrite: true,
    });
    setTimeout(() => {
      menuOpen = false;
    }, 700);
  });
}

function addTestCartItems() {
  if (devModeAddTestCart && cartItemsState.cartItems.length === 0) {
    console.log("🛒 Ajout de produits de test au panier...");
    const testProducts = [
      {
        id: "product-1",
        name: "Pro Team Training Jersey",
        price: 120,
        image: "/assets/images/home/products/1.png",
        quantity: 2,
      },
      {
        id: "product-3",
        name: "Pro Team Base Layer",
        price: 85,
        image: "/assets/images/home/products/3.png",
        quantity: 1,
      },
      {
        id: "product-5",
        name: "Pro Team Aero Jersey",
        price: 220,
        image: "/assets/images/home/products/5.png",
        quantity: 1,
      },
    ];

    cartItemsState.cartItems = testProducts;
    cartItemsState.cartItemsQuantity = testProducts.reduce(
      (sum, item) => sum + item.quantity,
      0
    );
    console.log(
      `✅ ${cartItemsState.cartItemsQuantity} produits ajoutés au panier`
    );
  }
}

function startApp() {
  if (devMode) {
    console.log(`🚀 MODE DEV ACTIVÉ - Chargement de la page: ${devModePage}`);
    appState.introCompleted = true;

    if (devModePage === "cart") {
      addTestCartItems();
    }

    setupRouter(devModePage);
  } else {
    setupRouter();
  }
}

Promise.all(assets.map(loadAsset)).then(() => {
  startApp();
});
